import React from "react";
import { PageWrapper } from "@/components/PageWrapper";
import GitchaProPage from "@/components/GitchaProPage";

const AgentGitchaPro = () => (
  <PageWrapper>
    <div className="m-0">
      <div className="main-content p-0 pb-4 agent-no-login-content">
        <div className="agent-dashboard-wrap">
          <GitchaProPage />
        </div>
      </div>
    </div>
  </PageWrapper>
);

export default AgentGitchaPro;
